var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.63604 7.36396C8.2875 4.7125 9.61323 3.38677 11.2178 3.13263C11.736 3.05055 12.264 3.05055 12.7822 3.13263C14.3868 3.38677 15.7125 4.7125 18.364 7.36396V7.36396C19.5183 8.51833 20.0955 9.09551 20.455 9.80112C20.5739 10.0345 20.6743 10.2769 20.7553 10.526C21 11.2791 21 12.0954 21 13.7279V18C21 19.6569 19.6569 21 18 21V21C16.3431 21 15 19.6569 15 18V17C15 15.3431 13.6569 14 12 14V14C10.3431 14 9 15.3431 9 17V18C9 19.6569 7.65685 21 6 21V21C4.34315 21 3 19.6569 3 18V13.7279C3 12.0954 3 11.2791 3.24472 10.526C3.32566 10.2769 3.42605 10.0345 3.54497 9.80112C3.90449 9.09551 4.48167 8.51833 5.63604 7.36396V7.36396Z",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.afcb20be008c3a69aa1b4edc9c13998d.svg";
export { ForwardRef as ReactComponent };